<template>
  <warehouse-home config-module="320004" lob="SI" />
</template>

<script>
import WarehouseHome from '@/components/Cargo/Warehouse/warehouseHome'
export default {
  name: 'SIWarehouseModule',
  components: { WarehouseHome }
}
</script>

<style scoped>

</style>
